import { Injectable } from '@angular/core';
import { BasePageMetaResolver, PageType, ProductSearchService, RoutingService, SearchPageMetaResolver, TranslationService } from '@spartacus/core';
import { combineLatest, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UigSearchPageMetaResolver extends SearchPageMetaResolver {

  constructor(
    routingService: RoutingService,
    productSearchService: ProductSearchService,
    translation: TranslationService,
    basePageMetaResolver?: BasePageMetaResolver
  );
  constructor(
    protected routingService: RoutingService,
    protected productSearchService: ProductSearchService,
    protected translation: TranslationService,
    protected basePageMetaResolver: BasePageMetaResolver
  ) {
    super(routingService, productSearchService, translation, basePageMetaResolver);
    this.pageType = PageType.CONTENT_PAGE;
    this.pageTemplate = 'SearchResultsListPageTemplate';
  }

  resolveTitle(): Observable<string> {
    const sources = [this.total$, this.query$];
    return combineLatest(sources).pipe(
      switchMap(([count, query]) => {
        var value = '' + query;
        if (!query || query === '' || value.match(/(\d{5,} )/g)) {
          return this.translation.translate('search.pageMetaResolver.search', {
            count
          });
        }
        else {
          return this.translation.translate('pageMetaResolver.search.title', {
            count,
            query,
          });
        }
      })
    );
  }

}
